// src/components/FilterDropdown.js
import React from 'react';

const FilterDropdown = ({ filterOptionRef, onChange }) => (
  <div className="filter-dropdown">
    <select 
      value={filterOptionRef.current} 
      onChange={onChange}
      className="filter-select"
    >
      <option value="Show all">Show all</option>
      <option value="Hide all">Hide all</option>
      <option value="15 Min">15 Min</option>
      <option value="30 Min">30 Min</option>
      <option value="60 Min">60 Min</option>
      <option value="2 Std">2 Std</option>
      <option value="3 Std">3 Std</option>
      <option value="Im Einsatz">Im Einsatz</option>
      <option value="Abgemeldet N/A">Abgemeldet N/A</option>
      <option value="Im Betrieb">Im Betrieb</option>
    </select>
  </div>
);

export default FilterDropdown;